module.exports = __webpack_public_path__ + "static/img/pic_teacher.3e9b5a19.png";